import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "../components/ui/DropdownMenu";
import { useGridPrefsStore } from "../store/gridPrefsStore";

export function MenuBarToolsMenu({
  onOpenCommandPalette,
  onOpenLayouts,
}: {
  onOpenCommandPalette: () => void;
  onOpenLayouts: () => void;
}) {
  const { theme, setTheme } = useGridPrefsStore();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>Tools ▾</DropdownMenuTrigger>
      <DropdownMenuContent minWidth={200}>
        <DropdownMenuItem onSelect={onOpenCommandPalette}>
          Command palette <span className="float-right text-muted">⌘K</span>
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={onOpenLayouts}>Grid layouts…</DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onSelect={() => setTheme(theme === "dark" ? "light" : "dark")}
        >
          {theme === "dark" ? "☀ Switch to light theme" : "☾ Switch to dark theme"}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
